import toast, { Toaster } from 'react-hot-toast';

const ToastContainer = () => {
    return (
        <div>
            <Toaster />
        </div>
    );
};

export default ToastContainer;